import PageViewsContainer from './page-views-container';

export default PageViewsContainer;
